
import {
  Vue,
  Component,
  Prop,
  ModelSync,
  Inject
} from "vue-property-decorator";
import {
  ControlImageSize,
  OxygenControlsTreeContext
} from "@/oxygen/classes/lib/types";
import MediaSizeInput from "@/components/Reusable/CustomInputs/MediaSize/MediaSizeInput.vue";
import { uiStore } from "@/store/store-accessor";

@Component({
  components: { MediaSizeInput }
})
export default class OxygenMediaSizeInput extends Vue {
  @Prop()
  control!: ControlImageSize;

  @ModelSync("value", "input")
  syncedValue?: string;

  @Prop()
  placeholder?: string;

  @Inject({ from: "oxyContext" })
  readonly context!: OxygenControlsTreeContext;

  @Prop()
  path!: string;

  get breakpoint() {
    return uiStore.currentBreakpoint.id;
  }

  get background() {
    return this.context.getParentControlValueAt(
      this.path,
      this.breakpoint
    ) as Record<string, unknown>;
  }

  get image() {
    return this.background?.[this.imagePath];
  }

  get imagePath() {
    return this.control.imagePath || "image";
  }

  updateImage(image: unknown) {
    const parentPath = this.path.split(".").slice(0, -1).join(".");
    const fullPath = `${parentPath}.${this.imagePath}`;
    this.context.setControlValueAt(fullPath, this.breakpoint, image);
  }
}
